import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'

const changePassword = async (data: {
  old_password: string
  new_password: string
}) => {
  let fetchResponse = {
    data: {},
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post('/api/users/change_password/', data)
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

export const ddUsersAPI = {
  changePassword
}